var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: () => (_vm.showFilter = false),
          expression: "() => showFilter = false"
        }
      ],
      class: ["x-date-filters", { "full-width": _vm.fullWidth }]
    },
    [
      _c(
        "x-button",
        {
          class: [
            "input-field",
            "md-raised",
            "md-primary",
            "icon",
            { outline: !_vm.showFilter, "full-width": _vm.fullWidth }
          ],
          on: {
            click: function($event) {
              _vm.showFilter = true
            }
          }
        },
        [
          _c("ic-calendar", {
            attrs: {
              color: _vm.showFilter ? _vm.colors.white : _vm.colors.daddy
            }
          }),
          _vm._v("\n    " + _vm._s(_vm.selectedRangeLabel) + "\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _vm.showFilter
        ? _c("div", { staticClass: "date-filters-wrapper" }, [
            _c(
              "div",
              {
                class: [
                  "date-filters-modal",
                  { "align-left": _vm.modalAlignLeft }
                ]
              },
              [
                _c(
                  "div",
                  { staticClass: "calendar" },
                  [
                    _c("x-date-range-picker", {
                      attrs: { "default-range": _vm.dateRange },
                      on: { changed: _vm.changed }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "buttons-container" }, [
                  _vm.$slots["additional-filter"]
                    ? _c(
                        "div",
                        { staticClass: "additional-filter" },
                        [_vm._t("additional-filter")],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "range-selectors" },
                    [
                      _vm.showOverOneYearButton
                        ? _c(
                            "x-button",
                            {
                              class: [
                                "md-button",
                                "button",
                                "md-theme-default",
                                "md-dense",
                                "full-width",
                                {
                                  selected:
                                    _vm.predefinedRange === "over-one-years"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.setRange("over-one-years")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "advisory.customers-list.date-filters.over-one-years"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showExpiresOneMonthButton
                        ? _c(
                            "x-button",
                            {
                              class: [
                                "md-button",
                                "button",
                                "md-theme-default",
                                "md-dense",
                                "full-width",
                                {
                                  selected:
                                    _vm.predefinedRange === "expires-one-month"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.setRange("expires-one-month")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "advisory.customers-list.date-filters.expires-one-month"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "x-button",
                        {
                          class: [
                            "md-button",
                            "button",
                            "md-theme-default",
                            "md-dense",
                            "full-width",
                            { selected: _vm.predefinedRange === "last-month" }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.setRange("last-month")
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "advisory.customers-list.date-filters.last-month"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "x-button",
                        {
                          class: [
                            "md-button",
                            "button",
                            "md-theme-default",
                            "md-dense",
                            "full-width",
                            { selected: _vm.predefinedRange === "last-year" }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.setRange("last-year")
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "advisory.customers-list.date-filters.last-year"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "x-button",
                        {
                          class: [
                            "md-button",
                            "button",
                            "md-theme-default",
                            "md-dense",
                            "full-width",
                            { selected: _vm.predefinedRange === "since-start" }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.setRange("since-start")
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "advisory.customers-list.date-filters.since-start"
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _c(
                        "x-button",
                        {
                          staticClass:
                            "md-button button md-theme-default md-raised md-primary",
                          attrs: { disabled: !_vm.isValidRange },
                          on: { click: _vm.submit }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("buttons.apply")))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "x-button",
                        {
                          staticClass:
                            "md-button button md-theme-default md-raised md-primary outline",
                          on: { click: _vm.reset }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("buttons.reset")))])]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }